var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTermsError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 362.764,
    height: 177.114,
    viewBox: "0 0 362.764 177.114",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-424.868 421.271)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    fill: "#5CC7DB",
    d: "M502.551-416.534h47.364a1.894,1.894,0,0,1,1.9,1.886v.008h0a1.9,1.9,0,0,1-1.9,1.894H502.551a1.9,1.9,0,0,1-1.9-1.894h0A1.9,1.9,0,0,1,502.551-416.534Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    fill: "#5CC7DB",
    d: "M462.761-293.378h45.471a1.9,1.9,0,0,1,1.9,1.894h0a1.9,1.9,0,0,1-1.894,1.9H462.763a1.9,1.9,0,0,1-1.34-.556,1.892,1.892,0,0,1-.556-1.34h0a1.894,1.894,0,0,1,1.894-1.894Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    fill: "#5CC7DB",
    d: "M479.812-374.857h28.42a1.894,1.894,0,0,1,1.894,1.894h0a1.9,1.9,0,0,1-1.9,1.894h-28.42a1.9,1.9,0,0,1-1.9-1.894h0a1.9,1.9,0,0,1,1.9-1.894Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    fill: "#5CC7DB",
    d: "M460.871-374.857h5.684a1.9,1.9,0,0,1,1.9,1.894h0a1.9,1.9,0,0,1-1.9,1.894h-5.684a1.9,1.9,0,0,1-1.9-1.894h0A1.9,1.9,0,0,1,460.871-374.857Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    fill: "#5CC7DB",
    d: "M457.077-335.07h32.214a1.9,1.9,0,0,1,1.9,1.9h0a1.9,1.9,0,0,1-1.9,1.894H457.079a1.893,1.893,0,0,1-1.9-1.888v-.005h0a1.9,1.9,0,0,1,.554-1.34A1.89,1.89,0,0,1,457.077-335.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    fill: "#5CC7DB",
    d: "M426.768-335.07H440.03a1.894,1.894,0,0,1,1.9,1.888v.006h0a1.894,1.894,0,0,1-1.894,1.894H426.768a1.892,1.892,0,0,1-1.9-1.886v-.007h0a1.884,1.884,0,0,1,.554-1.34,1.9,1.9,0,0,1,1.34-.555Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    fill: "#5CC7DB",
    d: "M513.916-253.591h36a1.888,1.888,0,0,1,1.341.554,1.888,1.888,0,0,1,.554,1.34h0a1.886,1.886,0,0,1-.554,1.34,1.9,1.9,0,0,1-1.34.554h-36a1.9,1.9,0,0,1-1.34-.554,1.882,1.882,0,0,1-.554-1.34h0a1.892,1.892,0,0,1,.556-1.34,1.886,1.886,0,0,1,1.34-.554Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "b",
    fill: "none",
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2px",
    y2: 52.812,
    transform: "translate(727.993 -330.323)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "b",
    fill: "none",
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2px",
    y2: 2.825,
    transform: "translate(727.993 -267.739)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    fill: "none",
    stroke: "#5CC7DB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "3px",
    d: "M762.07-302.131l-28.187-48.385a6.814,6.814,0,0,0-9.315-2.463,6.807,6.807,0,0,0-2.459,2.457l-13.028,20.373"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    fill: "none",
    stroke: "#5CC7DB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "3px",
    d: "M670.274-261.34a6.816,6.816,0,0,0,2.961,8.238,6.816,6.816,0,0,0,3.438.929H779.32a6.814,6.814,0,0,0,6.812-6.816,6.81,6.81,0,0,0-.925-3.427l-1.455-2.5"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "d",
    fill: "none",
    cx: 88.099,
    cy: 88.099,
    r: 88.099,
    transform: "translate(534.304 -421.271)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    fill: "none",
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeWidth: "2.647px",
    d: "M704.407-359.838a86.155,86.155,0,0,1,4.2,26.664,85.81,85.81,0,0,1-16.415,50.619"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    fill: "none",
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeWidth: "2.647px",
    d: "M692.185-282.554A86.088,86.088,0,0,1,622.4-246.973a86.2,86.2,0,0,1-86.2-86.2h0a86.2,86.2,0,0,1,86.2-86.2h0a86.023,86.023,0,0,1,30.836,5.678"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    fill: "none",
    d: "M710.451-330.159A88.1,88.1,0,0,1,622.4-245.074a88.1,88.1,0,0,1-88.1-88.1,88.1,88.1,0,0,1,88.1-88.1,88.1,88.1,0,0,1,88.1,88.1q0,1.514-.051,3.013"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    fill: "#5CC7DB",
    stroke: "#5CC7DB",
    strokeLinecap: "round",
    strokeWidth: "2.647px",
    d: "M664.739-408.287a85.88,85.88,0,0,1,15.1,10.824"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    fill: "none",
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeWidth: "2.647px",
    d: "M708.034-343.131a86.085,86.085,0,0,1-27.3,73.419,86.2,86.2,0,0,1-121.8-5.124l0,0h0a86.2,86.2,0,0,1,5.125-121.8l0,0h0a86.042,86.042,0,0,1,26.545-16.687"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "d",
    fill: "none",
    cx: 88.099,
    cy: 88.099,
    r: 88.099,
    transform: "translate(534.835 -420.355)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    fill: "#5CC7DB",
    stroke: "#5CC7DB",
    strokeLinecap: "round",
    strokeWidth: "2.647px",
    d: "M687.345-389.589q1.959,2.2,3.774,4.549"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    fill: "#5CC7DB",
    width: 5.319,
    height: 47.863,
    rx: 1.857,
    transform: "translate(618.393 -379.278)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    fill: "#5CC7DB",
    width: 5.319,
    height: 65.349,
    rx: 1.857,
    transform: "translate(618.087 -333.041) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    fill: "#FFF",
    d: "M772.452-286.72l8.01,13.873a1.056,1.056,0,0,1-.37,1.446h0a1.06,1.06,0,0,1-1.439-.406l-8.01-13.873a1.059,1.059,0,0,1,.368-1.449h0a1.06,1.06,0,0,1,1.439.406Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    fill: "#FFF",
    d: "M767.115-295.964l1.6,2.771a1.059,1.059,0,0,1-.368,1.449h0a1.059,1.059,0,0,1-1.439-.406l-1.6-2.771a1.059,1.059,0,0,1,.368-1.449h0A1.059,1.059,0,0,1,767.115-295.964Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTermsError);
export default __webpack_public_path__ + "static/media/termsError.51c7b3c7.svg";
export { ForwardRef as ReactComponent };